import Tabs from '../../js/src/tabs.js';
import { scrollToY } from "../../js/helpers";

(function ($) {

    if ($('.block.tabs').length) {

        $('.block.tabs').each(function(index, tab) {
            new Tabs($(tab), '.tab-group .tab-group__item');

            $(tab).bind('easytabs:before', (e) => {
                const tabY = $(tab).position().top;
                if (window.scrollY >= tabY) {
                    scrollToY(tabY, 200);
                }
            });

        });
    }

})(jQuery);
